import XLSX from 'xlsx';
import FileSaver from 'file-saver';

export default {
    data() {
        return {
            // 搜索条件
            form: {
                // 姓名
                user_name: '',
                // 身份证号
                idcard: '',
                // 编号
                idcard: '',
                // 单位
                company: '',
                // 大于或等于上次学习时间
                last_study_time_egt: '',
                // 小于或等于上次学习时间
                last_study_time_eglt: '',
                // 大于或等于完成时间
                study_end_time_egt: '',
                // 小于或等于完成时间
                study_end_time_eglt: '',
                // 学习状态
                learningState: '',
                // 所属年度
                year: '',
                // 专业
                category_name: '',
            },
            // 学习状态
            studyState: [{
                value: 0,
                label: '未开始'
            },
            {
                value: 1,
                label: '学习中'
            },
            {
                value: 2,
                label: '已完成'
            }
            ],
            // 所属年度
            years: [],
            // 课程包名称
            categoryNames: [{
                value: 1,
                label: '计算机'
            },
            {
                value: 2,
                label: '城建'
            }
            ],
            // 学习情况数据
            tableData: [],
            // 已选择的表格行
            selections: [],
            // 已选择的表格行的id
            selectionIds: [],
            // 单个学员的学习进度
            studentData: {},
            // 控制是否显示学员资料
            isShow: false,
            // 总条数
            total: 20,
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 10,
            // 导出excel
            excelDialog: false,
            exceldata: {
                offset: 0,
                length: 0
            },
            // 管理员权限
            authorizationObject: '',
            // 单个学员的列表
            productList: [],
            // 导出显示加载中
            exportLoading: false,
            //频道ID
            shopID:null
        }
    },
    methods: {
        // 一键完成课程包
        currentProgress() {
            // 先判断是否有选择学员且最多选择一名学员
            if (this.selectionIds.length === 0 || this.selectionIds.length !== 1) {
                this.$message.warning('抱歉！请选择一名学员！');
                return;
            }

            // console.log(this.selections,'selections')

            this.$confirm('是否把学员  ‘' + this.selections[0].user_name + '’  的《' + this.selections[0].category_name + '》的进度改为已完成', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$post('category_order/oneFinish', {
                    token: this.$store.state.authority_management,
                    category_order_id: this.selections[0].category_order_id,
                    order_id: this.selections[0].order_id,
                    category_id: this.selections[0].category_id,
                    category_name: this.selections[0].category_name,
                    owner_id: this.selections[0].owner_id
                }).then(res => {
                    // console.log(res)
                    if (res.data.status == 'success') {
                        this.$message({
                            type: 'success',
                            message: '操作成功'
                        });
                        this.getData();

                    } else {
                        this.$message({
                            type: 'error',
                            message: '操作失败，请重试'
                        });
                    }
                }).catch(err => {
                    this.$message({
                        type: 'error',
                        message: '操作失败，请重试'
                    });
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },

        search() {
            this.currentPage = 1;
            this.getData();
        },

        // 当选择项发生变化时会触发该事件
        handleSelectionChange(selections) {
            console.log(selections)
            this.studentData = selections[0];
            this.selections = selections;
            console.log(this.studentData, 'studentData')
            // 取出选择的表格行的id
            this.selectionIds = selections.map(item => item.category_id);
        },

        // 查看学员的学习进度
        toView() {
            // 先判断是否有选择学员且最多选择一名学员
            if (this.selectionIds.length === 0 || this.selectionIds.length !== 1) {
                this.$message.warning('抱歉！请选择一名学员！');
                return;
            }
            // console.log(this.selectionIds[0])
            // 发送请求获取学员的学习进度
            console.log(this.selections)
            this.$post('userAdmin/coursePackageStudyDetail', {
                category_id: this.selectionIds[0],
                owner_id: this.selections[0].owner_id,
                order_id: this.selections[0].order_id,
                category_order_id: this.selections[0].category_order_id,
                token: this.$store.state.authority_management,
            }).then(res => {
                // console.log(res)
                this.productList = res.data.result
            })

            // 显示学员资料对话框
            this.isShow = true;


        },

        // 打印证书
        print() {
            // 先判断是否有选择学员且最多选择一名学员
            if (this.selectionIds.length === 0 || this.selectionIds.length !== 1) {
                this.$message.warning('抱歉！请选择一名学员！');
                return;
            }

            console.log(this.selections, 'selections')

            // 选择的进度不为1，不让打印进度
            if (this.selections[0].category_progress !== 1) {
                this.$message.warning('抱歉！课程包的进度未完成，不能打印证书！');
                return;
            }

            let owner_ids = []
            let category_ids = []
            this.selections.map(item => {
                owner_ids.push(item.owner_id)
                category_ids.push(item.category_id)
            })

            let data = {
                token: this.$store.state.authority_management,
                ownerIds: JSON.stringify(owner_ids),
                category_ids: JSON.stringify(category_ids)
            }
            // 发送请求打印证书
            this.$post('cers/printPdf', data).then(res => {
                console.log(res)
                window.open(res.data.result)
            })
        },

        // 每页显示条数改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.getData();
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
            this.getData();
        },

        // 获取数据
        getData() {
            this.$post('userAdmin/coursePackageStudyStatus', {
                token: this.$store.state.authority_management,
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                shop_id: this.$store.state.store.id,
                name: this.form.user_name,
                idcard: this.form.idcard,
                company: this.form.company,
                last_study_time_egt: this.form.last_study_time_egt,
                last_study_time_elt: this.form.last_study_time_eglt,
                study_end_time_egt: this.form.study_end_time_egt,
                study_end_time_elt: this.form.study_end_time_eglt,
                study_status: this.form.learningState,
                year: this.form.year,
                category_name: this.form.category_name,
            }).then(res => {
                this.tableData = res.data.result.data;
                this.total = res.data.result.total;
            })
        },

        // 导出excel
        exportExcel() {
            this.excelDialog = true;
            //前端导出
            // let wb = XLSX.utils.table_to_book(document.getElementById('out-table'), {
            // 	raw: true
            // })

            // let wbout = XLSX.write(wb, {
            // 	bookType: 'xlsx',
            // 	bookSST: true,
            // 	type: 'array'
            // })
            // try {
            // 	FileSaver.saveAs(new Blob([wbout], {
            // 		type: 'application/octet-stream'
            // 	}), 'test.xlsx')
            // } catch (e) {
            // 	if (typeof console !== 'undefined') console.log(e, wbout)
            // }
            // return wbout
        },

        //确认导出
        confirmexport() {
            this.exportLoading = true;
            this.excelDialog = false;
            let data = {
                token: this.$store.state.authority_management,
                offset: this.exceldata.offset,
                length: this.exceldata.length
            }
            // console.log((this.form))
            if (this.form.user_name) {
                data.user_name = this.form.user_name
            }
            if (this.form.idcard) {
                data.idcard = this.form.idcard
            }
            if (this.form.company) {
                data.company = this.form.company
            }
            if (this.form.last_study_time_egt) {
                data.last_study_time_egt = this.form.last_study_time_egt
            }
            if (this.form.last_study_time_eglt) {
                data.last_study_time_elt = this.form.last_study_time_eglt
            }
            if (this.form.study_end_time_egt) {
                data.study_end_time_egt = this.form.study_end_time_egt
            }
            if (this.form.study_end_time_eglt) {
                data.study_end_time_elt = this.form.study_end_time_eglt
            }
            if (this.form.learningState) {
                data.learningState = this.form.learningState
            }
            if (this.form.year) {
                data.year = this.form.year
            }
            if (this.form.category_name) {
                data.category_name = this.form.category_name
            }

            this.$post('userAdmin/coursePackageStudyStatusExport ', data).then(res => {
                this.exportLoading = false;
                window.open(res.data.result)
            })
        },

        // 在输入框输入数据时触发
        inputNumber(e) {
            e >= 20000 ? this.exceldata.length = 20000 : this.exceldata.length = e;
        },

        // 获取年度数组
        getYearList() {
            this.$post('product_category/get_year', {
                available: 1,
                offset: 0,
                length: 19999
            }).then(res => {
                this.years = res.data.result.data;
            });
        }
    },
    filters: {
        studyStateFilter(value) {
            if (value == 0) {
                return '未开始'
            } else if (value == 1) {
                return '已完成'
            } else {
                return '学习中';
            }
        },

        studyProgress(value) {
            return value * 100 + '%';
        }
    },
    created() {
        this.authorizationObject = JSON.parse(sessionStorage.getItem('authorizationObject'))
        this.getData();
        this.getYearList();
        //获取频道ID
        this.shopID=this.$store.state.newShopId
    }
}
